/* Theme-scoped SC help copy. Never edit controls, names, values, labels or properties. */
(function () {
  'use strict';
  if (window.ptContentHelpInstalled) return;
  window.ptContentHelpInstalled = true;
  var observed = new WeakSet();
  var rules = [
    {
      selector: 'input.rb_1061756_432460[name="properties[Delivery Date Crucial?]"]',
      before: 'Order lead time can be calculated from the "Order Lead Time" table on this page.',
      after: 'The reference in the No option is to our former lead-time table. Please contact us to confirm current timing. Select Yes if your delivery date is crucial.'
    },
    {
      selector: 'input.da_1043268_432460[name="properties[Dispatch Date]"]',
      before: 'Due to multiple factors outside of our control we cannot offer a delivery date guarantee, though we always do our best. Please refer to "Order Lead Times" table for calculation of lead time, unless you\'ve checked with us and we\'ve said an earlier dispatch will be OK.',
      after: 'Due to multiple factors outside of our control we cannot offer a delivery date guarantee, though we always do our best. Please contact us to confirm dispatch timing, unless we have already agreed an earlier dispatch with you.'
    }
  ];
  function update(root) {
    rules.forEach(function (rule) {
      root.querySelectorAll(rule.selector).forEach(function (input) {
        var option = input.closest('.bold_option');
        var help = option && option.querySelector('.bold_help_text > small');
        if (help && help.children.length === 0 && help.textContent.trim() === rule.before) {
          help.textContent = rule.after;
        }
      });
    });
  }
  function start() {
    document.querySelectorAll('[id^="product_form_"]').forEach(function (form) {
      if (observed.has(form)) return;
      observed.add(form);
      update(form);
      var observer = new MutationObserver(function () { update(form); });
      observer.observe(form, { childList: true, subtree: true, characterData: true });
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, { once: true });
  else start();
  document.addEventListener('shopify:section:load', start);
}());
